import React from 'react';
import { Briefcase } from 'lucide-react';
import { formatCurrency, formatPercent, formatDuration } from '../../../../utils/formatters';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/Card';
import DefinitionItem from './DefinitionItem';

export default function GenericOverview({ transaction }) {
  const investors = transaction.participants?.filter(p => p.role === 'Investisseur' || p.role === 'Prêteur') || [];
  const totalEngaged = investors.reduce((sum, p) => sum + (p.committedAmount || 0), 0);

  return (
    <Card className="shadow-hp-sm">
      <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] px-5 py-4">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-muted text-primary">
          <Briefcase className="h-4.5 w-4.5" />
        </div>
        <div>
          <CardTitle className="text-base font-semibold text-primary">Informations de l'opération</CardTitle>
          <p className="mt-0.5 text-sm text-subtle">Structure et paramètres génériques de la transaction.</p>
        </div>
      </CardHeader>

      <CardContent className="p-5">
        <dl className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
          <DefinitionItem
            label="Montant cible"
            value={formatCurrency(transaction.targetAmount, transaction.currency)}
            emphasis
          />

          <DefinitionItem
            label="Montant engagé"
            value={formatCurrency(totalEngaged, transaction.currency)}
          />

          <DefinitionItem
            label="Taux de rendement cible"
            value={formatPercent(transaction.yieldRate)}
          />

          <DefinitionItem
            label="Durée"
            value={formatDuration(transaction.durationMonths)}
          />
        </dl>
      </CardContent>
    </Card>
  );
}
